<div class="interview-status-widget">
  <div class="status-card">
    <div class="header-row">
      <div class="interview-status-header">
        <span class="title">{{ statusWidget.InterviewsStatus }}</span>
        <emerald-icon
          [icon]="'open_in_new'"
          [color]="priority.grey"
          [fontsizeInRem]="fontSize_opentab"
          (click)="navigateToPositionsList()"
        ></emerald-icon>
      </div>
      <div class="select-container">
        <emerald-menu
          [opened]="opened"
          [position]="'bottom_end'"
          [targetElement]="navTemplate"
          [menuTemplate]="menuTemplate"
          (openChange)="opened = $event"
        ></emerald-menu>
        <ng-template #navTemplate>
          <emerald-button
            [label]="'Filter'"
            [size]="'Small'"
            [type]="'Secondary'"
            [icon]="'filter_list'"
            [iconPosition]="'Left'"
            (onClick)="this.opened = !this.opened"
          ></emerald-button>
        </ng-template>
        <ng-template #menuTemplate>
          <app-interview-status-widget-filter
          [breakdown]="candidateBreakdown"
          (applyFilter)="onApplyFilter($event)"
          ></app-interview-status-widget-filter>
        </ng-template>
      </div>
    </div>
    <div class="level-bars">
      <div class="level-row" *ngFor="let level of levels; let i = index">
        <span class="level-label">{{ level }}</span>
        <div class="level-track">
          <ng-container *ngIf="interviewStatus.length === 2">
            <div class="seg pending"
                 *ngIf="interviewStatus[0].values[i] > 0"
                 [style.width.%]="getLevelSegmentPct(i, 0)"
                 [attr.title]="'Pending L' + (i+1) + ': ' + interviewStatus[0].values[i]">
              <span class="seg-val">{{ interviewStatus[0].values[i] }}</span>
            </div>
            <div class="seg rejected"
                 *ngIf="interviewStatus[1].values[i] > 0"
                 [style.width.%]="getLevelSegmentPct(i, 1)"
                 [attr.title]="'Rejected L' + (i+1) + ': ' + interviewStatus[1].values[i]">
              <span class="seg-val">{{ interviewStatus[1].values[i] }}</span>
            </div>
          </ng-container>
        </div>
        <span class="level-total">{{ getLevelTotal(i) }}</span>
      </div>
      <div class="bar-legend">
        <span class="legend-item"><span class="dot pending"></span>{{ statusWidget.Pending }}</span>
        <span class="legend-item"><span class="dot rejected"></span>{{ statusWidget.Rejected }}</span>
      </div>
    </div>
  </div>

  <div class="status-card profiles-in-section">
    <div class="profiles-header">
      <h3 class="profiles-in-title">{{ profileLabels.ProfilesIn }}</h3>
      <span class="profiles-total">{{ profilesTotal }}</span>
    </div>
    <div class="profiles-stack-track" *ngIf="profilesTotal > 0">
      <div class="seg open" *ngIf="openCount > 0" [style.width.%]="profilePct(openCount)" [attr.title]="profileLabels.Open + ': ' + openCount">
        <span class="seg-val" *ngIf="profilePct(openCount) > 6">{{ openCount }}</span>
      </div>
      <div class="seg in-progress" *ngIf="onboardingInProgressCount > 0" [style.width.%]="profilePct(onboardingInProgressCount)" [attr.title]="profileLabels.OnboardingInProgress + ': ' + onboardingInProgressCount">
        <span class="seg-val" *ngIf="profilePct(onboardingInProgressCount) > 6">{{ onboardingInProgressCount }}</span>
      </div>
      <div class="seg joined" *ngIf="joinedCount > 0" [style.width.%]="profilePct(joinedCount)" [attr.title]="profileLabels.Joined + ': ' + joinedCount">
        <span class="seg-val" *ngIf="profilePct(joinedCount) > 6">{{ joinedCount }}</span>
      </div>
      <div class="seg dropped" *ngIf="candidateDroppedCount > 0" [style.width.%]="profilePct(candidateDroppedCount)" [attr.title]="profileLabels.Dropped + ': ' + candidateDroppedCount">
        <span class="seg-val" *ngIf="profilePct(candidateDroppedCount) > 6">{{ candidateDroppedCount }}</span>
      </div>
    </div>
    <div class="profiles-legend">
      <span class="legend-item"><span class="dot open"></span>{{ profileLabels.Open }} <strong>{{ openCount }}</strong></span>
      <span class="legend-item"><span class="dot in-progress"></span>{{ profileLabels.OnboardingInProgress }} <strong>{{ onboardingInProgressCount }}</strong></span>
      <span class="legend-item"><span class="dot joined"></span>{{ profileLabels.Joined }} <strong>{{ joinedCount }}</strong></span>
      <span class="legend-item"><span class="dot dropped"></span>{{ profileLabels.Dropped }} <strong>{{ candidateDroppedCount }}</strong></span>
    </div>
  </div>
</div>
